import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import ContactLists from '@/src/account/components/ContactLists';
import MyAccount from '@/src/account/components/MyAccount';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import withAuthentication from '@/src/shared/components/WithAuthentication';
import FullProfileProvider from '@/src/shared/utils/FullProfileProvider';

const ContactListsPage = props => {
  return (
    <Layout>
      <Section bgColor="gray" halfPad>
        <Container>
          <MyAccount
            mainContent={
              <FullProfileProvider>
                <ContactLists />
              </FullProfileProvider>
            }
          />
          <WebLogImage path="/account/contact-lists" title="My Contact Lists" />
        </Container>
      </Section>
    </Layout>
  );
};

export default withAuthentication(ContactListsPage);
